import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import DeptCategoryForm from '../components/forms/DeptCategoryForm';
import '../styles/EmployeeMaster.css';
import DeptCategoryTable from '../components/DeptCategoryTable';

const DeptCategoryEditModel = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // ✅ Get ID from route

  const [deptcategoryData, setDeptCategoryData] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Show modal only if URL starts with /sbu/edit
  const showModal = location.pathname.startsWith('/deptcategory/edit');

  const handleCloseModal = () => {
    navigate('/deptcategory'); // Go back to list
  };

  // ✅ Fetch SBU details by ID
  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      fetch(`${baseUrl}/getDeptCategoryById/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            setDeptCategoryData(data.data);
          } else {
            setDeptCategoryData(null);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching Dept Category by ID:', err);
          setLoading(false);
        });
    }
  }, [id, showModal]);

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Dept Category Master</h2>
      </div>

      {/* Table of SBUs */}
      <DeptCategoryTable />

      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Dept Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" /> Loading...
            </div>
          ) : deptcategoryData ? (
            <DeptCategoryForm deptcategoryId={id} initialData={deptcategoryData} /> // ✅ Pass data to form
          ) : (
            <p className="text-center">No data found for this Dept Category.</p>
          )}
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default DeptCategoryEditModel;
